module.exports = __webpack_public_path__ + "static/media/icn-download-16px.b624725f.svg";